/**
 * en-GB messages added by Phase 1 task S8 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s8EnGB = {
    'nav.agreements': 'Agreements',
    'nav.agreements.desc': 'Signed notices, sealed and verifiable',
    'error.agreement_not_sealed': 'This agreement has not been sealed yet.',
    'error.agreement_not_failed': 'Only an agreement that failed to seal can be tried again.',
    'error.pdf_required': 'Please choose a PDF file.',
    // Why sealing failed (shown in the portal next to a failed agreement)
    'agreement.error.no_signing_key': 'The signing key is not set up on the server, so agreements cannot be sealed yet.',
    'agreement.error.signing_key_unknown': 'The signing key file does not match any CloudSign signing certificate.',
    'agreement.error.acceptance_missing': 'The acceptance this agreement was made from no longer exists.',
    'agreement.error.render_failed': 'The agreement PDF could not be made.',
    'agreement.error.seal_failed': 'Sealing failed. It will be tried again.',
    // Problems Verify reports
    'agreement.problem.pdf_changed': 'The stored PDF no longer matches its fingerprint. It has been changed since it was sealed.',
    'agreement.problem.pdf_missing': 'The stored PDF could not be found.',
    'agreement.problem.signature_invalid': 'The PDF is not signed by a CloudSign signing key, or it has been changed.',
    'agreement.problem.chain_gap': 'A record is missing from the chain here.',
    'agreement.problem.chain_hash_mismatch': 'A record in the chain has been changed.',
    'agreement.problem.chain_head_mismatch': 'The end of the chain does not match the records. Records may have been removed.',
    'agreement.problem.chain_entry_missing': 'This agreement is not part of the chain.',
    // Email sent to administrators when the nightly check finds a broken chain
    'email.agreements.chain_broken.subject': '{tenant}: signed agreements need attention',
    'email.agreements.chain_broken.body': 'The nightly check of the signed agreements for {tenant} found that the records do not add up. A record may have been changed or removed. Please contact CloudSign support and do not delete anything.',
    'email.agreements.chain_broken.button': 'Open agreements',
    'settings.agreements': 'Signed agreements',
    'settings.agreements.enabled': 'Make a signed PDF for every accepted notice',
    'settings.agreements.timestamping': 'Trusted timestamps',
    'settings.agreements.timestamping.enabled': 'Timestamp the agreement records every day (needs a timestamp service set up by CloudSign)',
    'settings.agreements.tsaUrl': 'Timestamp service address (blank = timestamps unavailable)',
    'settings.agreements.chainCheckHours': 'Check the agreement records every this many hours (0 = never check automatically)',
};
//# sourceMappingURL=s8.js.map